'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var mh = require('multihashes');

var utils = require('../utils');

var Run = require('./run');
/**
 * Divide peers up into disjoint paths (subqueries). Any peer can only be used once over all paths.
 * Within each path, query peers from closest to farthest away.
 */


var Query = /*#__PURE__*/function () {
  /**
   * User-supplied function to set up an individual disjoint path. Per-path
   * query state should be held in this function's closure.
   * @typedef {makePath} function
   * @param {number} pathNum - Numeric index from zero to numPaths - 1
   * @returns {queryFunc} - Function to call on each peer in the query
   */

  /**
   * Query function.
   * @typedef {queryFunc} function
   * @param {PeerId} next - Peer to query
   * @param {function(Error, Object)} callback - Query result callback
   */

  /**
   * Create a new query. The makePath function is called once per disjoint path, so that per-path
   * variables can be created in that scope. makePath then returns the actual query function (queryFunc) to
   * use when on that path.
   *
   * @param {DHT} dht - DHT instance
   * @param {Buffer} key
   * @param {makePath} makePath - Called to set up each disjoint path. Must return the query function.
   */
  function Query(dht, key, makePath) {
    _classCallCheck(this, Query);

    this.dht = dht;
    this.key = key;
    this.makePath = makePath;
    this._log = utils.logger(this.dht.peerInfo.id, 'query:' + mh.toB58String(key));
    this.running = false;
    this._onStart = this._onStart.bind(this);
    this._onComplete = this._onComplete.bind(this);
  }
  /**
   * Run this query, start with the given list of peers first.
   *
   * @param {Array<PeerId>} peers
   * @returns {Promise}
   */


  _createClass(Query, [{
    key: "run",
    value: function () {
      var _run = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peers) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.dht._queryManager.running) {
                  _context.next = 3;
                  break;
                }

                this._log.error('Attempt to run query after shutdown');

                return _context.abrupt("return", {
                  finalSet: new Set(),
                  paths: []
                });

              case 3:
                if (!(peers.length === 0)) {
                  _context.next = 6;
                  break;
                }

                this._log.error('Running query with no peers');

                return _context.abrupt("return", {
                  finalSet: new Set(),
                  paths: []
                });

              case 6:
                this._run = new Run(this);

                this._log("query running with K=".concat(this.dht.kBucketSize, ", A=").concat(this.dht.concurrency, ", D=").concat(Math.min(this.dht.disjointPaths, peers.length)));

                this._run.once('start', this._onStart);

                this._run.once('complete', this._onComplete);

                return _context.abrupt("return", this._run.execute(peers));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function run(_x) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
    /**
     * Called when the run starts.
     */

  }, {
    key: "_onStart",
    value: function _onStart() {
      this.running = true;
      this._startTime = Date.now();

      this._log('query:start'); // Register this query so we can stop it if the DHT stops


      this.dht._queryManager.queryStarted(this);
    }
    /**
     * Called when the run completes (even if there's an error).
     */

  }, {
    key: "_onComplete",
    value: function _onComplete() {
      // Ensure worker queues for all paths are stopped at the end of the query
      this.stop();
    }
    /**
     * Stop the query.
     */

  }, {
    key: "stop",
    value: function stop() {
      this._log("query:done in ".concat(Date.now() - this._startTime, "ms"));

      if (this._run) {
        this._log("".concat(this._run.errors.length, " of ").concat(this._run.peersSeen.size, " peers errored (").concat(this._run.errors.length / this._run.peersSeen.size * 100, "% fail rate)"));
      }

      if (!this.running) {
        return;
      }

      this._run.removeListener('start', this._onStart);

      this._run.removeListener('complete', this._onComplete);

      this.running = false;
      this._run && this._run.stop();

      this.dht._queryManager.queryCompleted(this);
    }
  }]);

  return Query;
}();

module.exports = Query;